import { ADD_TO_DRAG_AND_DROP } from './mutation-types';

export const taskPlugin = (store) => {
  const moduleName = 'taskModule';
  const dragAndDropMutations = [`${moduleName}/${ADD_TO_DRAG_AND_DROP}`];

  store.subscribe((mutation) => {
    if (dragAndDropMutations.includes(mutation.type)) {
      store.dispatch(`${moduleName}/executeDragAndDrop`);
    }
  });
};
